"use client";

/**
 * Small link pieces of the staff login and the auth pages (AuthPageShell).
 */

import { ld } from "@/lib/theme/light-dark";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactElement } from "react";
import { ArrowLeftIcon } from "./login-form-icons";
import { INK } from "./login-shared";

/** Header CTA of the wide login. */
export function DemoCta(): ReactElement {
  const t = useTranslations("public.loginScreen");
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
      <span style={{ fontSize: 14, color: ld("rgba(11,15,25,0.55)", "rgba(250,250,250,0.55)") }}>
        {t("keinKonto")}
      </span>
      <Link
        href="/demo"
        className="mklogin-demo-pill"
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: INK,
          textDecoration: "none",
          border: `1px solid ${ld("rgba(11,15,25,0.16)", "rgba(250,250,250,0.16)")}`,
          padding: "9px 16px",
          borderRadius: 10,
          transition: "background .12s",
        }}
      >
        {t("demoBuchen")}
      </Link>
    </div>
  );
}

/** „Noch kein Konto? Demo buchen“ under the form. */
export function DemoFooterLink(): ReactElement {
  const t = useTranslations("public.loginScreen");
  return (
    <div
      style={{
        textAlign: "center",
        fontSize: 13.5,
        color: ld("rgba(11,15,25,0.6)", "rgba(250,250,250,0.6)"),
      }}
    >
      {t("keinKonto")}{" "}
      <Link
        href="/demo"
        className="mklogin-link mklogin-tap"
        style={{ color: INK, fontWeight: 600, textDecoration: "none" }}
      >
        {t("demoBuchen")}
      </Link>
    </div>
  );
}

/** „← Zur Website“ in the phone header (login) and on every auth page. */
export function WebsiteBackLink({
  label,
}: {
  readonly label: string;
}): ReactElement {
  return (
    <Link
      href="/"
      className="mklogin-website-link mklogin-tap"
      style={{
        gap: 6,
        fontSize: 13.5,
        fontWeight: 500,
        color: ld("rgba(11,15,25,0.6)", "rgba(250,250,250,0.6)"),
        textDecoration: "none",
        transition: "color .12s",
      }}
    >
      <ArrowLeftIcon />
      {label}
    </Link>
  );
}
